import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import emptyImages from 'assets/img/empty-images.svg';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as LotActionType from '../../constants';
import sortIconDown from 'assets/img/sort-amount-down-solid.svg';
import sortIconUp from 'assets/img/sort-amount-up-solid.svg';
import queryString from 'query-string';
import ViewInventory from './inventory-view';
import exitIcon from 'assets/img/exit.svg';

class ManageCategoryLot extends Component {
  static propTypes = {
    lot: PropTypes.object,
    dispatch: PropTypes.func,
    location: PropTypes.any,
    history: PropTypes.any,
    categoryList: PropTypes.array
  }

  constructor(props) {
    super(props);
    this.state = {
      sortName: false,
      isViewDetails: false
    };
  }

  componentDidMount() {
    console.log('inventory-list mount');
    this.fetchCategoryList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.lot && prevProps.lot.value !== this.props.lot.value) {
      this.fetchCategoryList();
    }
  }

  fetchCategoryList = () => {
    const { lot } = this.props;
    const { builderProfile } = lot.extensionValue;
    this.props.dispatch({
      type: LotActionType.GET_LIST_CATEGORY_HOME_INVENTORY_HOME_OWNER_ASYNC,
      params: {
        lotId: lot.value,
        builderHost: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken
        }
      }
    });
  }

  onViewItemsOfCategory = (id) => {
    const { location, history } = this.props;
    const queryParams = queryString.parse(location.search);

    history.push({
      pathname: location.pathname,
      search: queryString.stringify({
        ...queryParams,
        subTab: 'category-items',
        inventoryId: id
      })
    });
  }

  compareData = (a, b) => {
    const typeA = a.name.toLowerCase();
    const typeB = b.name.toLowerCase();

    if (this.state.sortName) {
      if (typeA > typeB) { return -1; }

      if (typeB > typeA) { return 1; }
    } else {
      if (typeA > typeB) { return 1; }

      if (typeB > typeA) { return -1; }
    }

    return 0;
  }

  onHandleSortMode = () => {
    this.setState({
      sortName: !this.state.sortName
    });
  }

  onViewDetailCategory = (id) => {
    const { history, location } = this.props;
    const queryParams = queryString.parse(location.search);
    this.setState({
      isViewDetails: true,
      viewDetailOfCategoryId: id
    });
  }

  render() {
    const { categoryList } = this.props;
    const queryParams = queryString.parse(location.search);
    const breadcrumbs = '';

    if (isEmpty(categoryList)) {
      return (
        <React.Fragment>
          <div className='manage-category-container container-fluid'>
            <div style={{ textAlign: 'center', margin: '5%' }} className='row'>
              <div className='col-md-12 col-xs-12'>
                <img
                  src='/images/empty-dashboard_bw.png'
                  alt='s1-empty-dashboard'
                  style={{ width: 485, opacity: 0.8 }}
                />
              </div>
              <div className='col-md-12 col-xs-12'>
                <h3 style={{ fontSize: 20 }}>No inventory, yet.</h3>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className='manage-category-container container-fluid'>
            {
              !this.state.isViewDetails &&
              <div className='row'>
                <div className='col-md-6 col-xs-6'>
                  <span onClick={this.onHandleSortMode} style={{ cursor: 'pointer' }} className='category-sort-icon'>{this.state.sortName ? <img src={sortIconUp} width={20} height={20} /> : <img src={sortIconDown} width={20} height={20} />}</span>
                </div>
              </div>
            }
            {
              !this.state.isViewDetails &&
              <div className='row margin-top-15'>
                {
                  categoryList.sort(this.compareData).map(el => {
                    return (
                      <React.Fragment>
                        <div key={el.id} style={{ marginBottom: 15 }} className='col-md-3 col-xs-6 col-sm-6 col-lg-3'>
                          <div className='category-list-items'>
                            <div className='category-list-item-wrapper'>
                              <div className='document-thumbnail-wrapper thumbnail-wrapper-item'>
                                <img style={{ width: '100%', height: 170, objectFit: 'contain' }} src={el.thumbnail && el.thumbnail.thumbnailUrl ? el.thumbnail.thumbnailUrl : emptyImages} />
                                <div onClick={() => this.onViewDetailCategory(el.id)} className='document-fade' />
                              </div>
                            </div>
                            <div className='category-list-items-project-name'>
                              <div className='category-name col-md-8 col-sm-8'>
                                <span>{el.name}</span>
                              </div>
                              <div className='category-name col-md-4 col-sm-4' onClick={() => this.onViewItemsOfCategory(el.id)} style={{ textAlign: 'right' }}>
                                <img src={exitIcon} width={24} height={24} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })
                }
              </div>
            }
            {
              this.state.isViewDetails &&
              <ViewInventory
                categoryId={this.state.viewDetailOfCategoryId}
                breadcrumbs={breadcrumbs}
                builderProfile={this.props.lot.extensionValue.builderProfile}
                goBack={() => { this.setState({ isViewDetails: false }); }}
                onViewItem={() => this.onViewItemsOfCategory(this.state.viewDetailOfCategoryId)}
              />
            }
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    categoryList: state.LotStore.categoryList
  };
};

export default withRouter(connect(mapStateToProps)(ManageCategoryLot));



// WEBPACK FOOTER //
// ./src/Lots/Components/Inventory/inventory-list.js